/* Mini Cart (product added to cart pop-up) */

document.addEventListener("liquid-ajax-cart:request-end", function(event) {
   const {requestState, cart, previousCart, sections} = event.detail;

  if (requestState.requestType === 'change' && requestState.responseData?.ok) {
    const currentCart = cart.items || [];

    previousCart.items.forEach((prevItem) => {
      const stillExists = currentCart.some(currItem => currItem.key === prevItem.key);
      if (!stillExists) {
        document.querySelector(".minicart__header h2.removed .product").innerHTML = prevItem.title;
        document.querySelector(".minicart__header h2.title").classList.add("hidden");
        document.querySelector(".minicart__header h2.removed").classList.remove("hidden");
      }
    });
  }
  else {
    document.querySelector(".minicart__header h2.removed .product").innerHTML = "";
    document.querySelector(".minicart__header h2.title").classList.remove("hidden");
    document.querySelector(".minicart__header h2.removed").classList.add("hidden");
  }
});

/* Main cart Page */
class GiftWrappingButton extends HTMLElement {
  constructor() {
    super();

    this.addToCartButton = this.querySelector("button");

    if (this.addToCartButton) {
      if (this.addToCartButton.classList.contains("added")) {
        this.addToCartButton.addEventListener(
          "click",
          this.removeGiftWrap.bind(this)
        );
      } else {
        this.addToCartButton.addEventListener(
          "click",
          this.addGiftWrap.bind(this)
        );
      }
    }
  }

  addGiftWrap(event) {
    event.preventDefault();
    const giftID = this.addToCartButton.dataset.variant;
    const existingQty = this.addToCartButton.dataset.qty;
    const options = {
      lastComplete: (requestState) => {
        const notePopup = document.querySelector(".cart__note-popup");
        notePopup.classList.add("!flex");
        window.scrollTo(0, 0);
      },
    };

    if (window.liquidAjaxCart && giftID) {
      window.liquidAjaxCart.add(
        {
          id: giftID,
          quantity: existingQty
        },
        options
      );

      const parentProductKey = event.target
        .closest(".cart-item")
        .getAttribute("data-key");

      window.liquidAjaxCart.change(
        {
          id: parentProductKey,
          properties: {
            _giftwrap: true,
            _giftwrap_product_id: "4513841414234",
            _giftwrap_variant_id: "31757797458010",
          },
          quantity: existingQty,
        },
        options
      );
    }

    this.addToCartButton.classList.add("added");
    window.scrollTo(0, 0);
  }

  removeGiftWrap(event) {
    event.preventDefault();

    const giftWrapProduct = document.querySelector(".js-gift-wrap-product");
    const existingQty = this.addToCartButton.dataset.qty;
    const giftQty = giftWrapProduct.dataset.qty;
    const giftWrapProductKey = giftWrapProduct.dataset.key;
    const minusQty = giftQty - existingQty;
    const parentProductKey = event.target
      .closest(".cart-item")
      .getAttribute("data-key");
    const options = {
      lastComplete: (requestState) => {
        console.log("lastComplete", requestState);
        const notePopup = document.querySelector(".cart__note-popup");
        notePopup.classList.remove("!flex");
        window.scrollTo(0, 0);
      },
    };

    window.liquidAjaxCart.change(
      {
        id: parentProductKey,
        properties: {
          _giftwrap: false,
          _giftwrap_product_id: "",
          _giftwrap_variant_id: "",
        },
        quantity: existingQty,
      },
      options
    );

    window.liquidAjaxCart.change(
      {
        id: giftWrapProductKey,
        quantity: minusQty,
      },
      options
    );

    this.addToCartButton.classList.remove("added");
    window.scrollTo(0, 0);
  }
}

customElements.define("gift-wrapping-atc", GiftWrappingButton);

class CartNote extends HTMLElement {
  constructor() {
    super();

    const openCartNote = document.querySelector(".js-open-cart-note");
    const notePopup = document.querySelector(".cart__note-popup");
    const closePopup = document.querySelectorAll(".js-close-popup");

    if (openCartNote) {
      openCartNote.addEventListener("click", function () {
        notePopup.classList.add("!flex");
        window.scrollTo(0, 0);
      });
    }

    closePopup.forEach((button) => {
      button.addEventListener("click", function () {
        notePopup.classList.remove("!flex");
        window.scrollTo(0, 0);
      });
    });
  }
}

customElements.define("cart-note", CartNote);
